export default __webpack_public_path__ + "static/media/curve-a.492d1f20.svg";